
import React from 'react';
import Header from './../../component/common/Header';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import Loader from './../../component/common/Loader';
import CONSTANT from './../../constant';
import { onChange, validateForm } from './../../utils';
import { updatePassword } from './../../actions/AuthAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            currentPassword: { name: 'currentPassword', value: '', error: '', isRequired: true },
            newPassword: { name: 'newPassword', value: '', error: '', isRequired: true },
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.changePassword;
    }

    render() {
        const { currentPassword, newPassword } = this.state;
        const { showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Change password</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form onSubmit={this.onSubmit}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Current password <sup>*</sup></label>
                                                        <input
                                                            type="password"
                                                            className={currentPassword.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            placeholder="Your current password"
                                                            name={currentPassword.name}
                                                            value={currentPassword.value}
                                                            onChange={this.onChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>New password <sup>*</sup></label>
                                                        <small style={{ color: '#6c757d', display: 'block', marginBottom: '5px' }}>
                                                            Must be at least 8 characters with uppercase, lowercase, number, and special character.
                                                        </small>
                                                        {newPassword.error.length > 0 && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginBottom: '5px' }}>{newPassword.error}</div>
                                                        )}
                                                        <input
                                                            type="password"
                                                            className={newPassword.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                            placeholder="Your new password"
                                                            name={newPassword.name}
                                                            value={newPassword.value}
                                                            onChange={this.onChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-10">
                                                    &nbsp;
                                                </div>
                                                <div className="col-md-3">
                                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    validatePassword = (password: string) => {
        if (password.length < 8) return 'Password must be at least 8 characters long';
        if (!/[A-Z]/.test(password)) return 'Password must contain at least one uppercase letter';
        if (!/[a-z]/.test(password)) return 'Password must contain at least one lowercase letter';
        if (!/[0-9]/.test(password)) return 'Password must contain at least one number';
        if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) return 'Password must contain at least one special character';
        return '';
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        const { currentPassword, newPassword } = this.state

        const passwordError = this.validatePassword(newPassword.value);
        if (passwordError) {
            this.setState({ newPassword: { ...newPassword, error: passwordError } });
            return;
        }

        if (validateForm(this)) {
            this.setState({ showLoader: true });
            updatePassword({ currentPassword: currentPassword.value, newPassword: newPassword.value })
                .then((res: any) => {
                    this.setState({ showLoader: false });
                    if (res) {
                        if (res.status === CONSTANT.static.apiStatus.success) {
                            alert(res.result.message);
                            onChange(this, 'currentPassword', '');
                            onChange(this, 'newPassword', '');
                        }
                        else {
                            alert(res.error);
                            onChange(this, 'currentPassword', '');
                            onChange(this, 'newPassword', '');

                        }
                    }
                })

        }
    }
}

export default ComponentName;